export default "__VITE_ASSET__c7876c4f__"